export { default as LiveStage } from "./main";

import * as Anchors from "./anchors";
import { default as routes } from "./routes";
export const livestage$ = {
  Anchors,
  routes,
};
